import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Form, Icon, Row, Col, Input } from 'antd';
import { Draggable } from 'react-beautiful-dnd';
// Services
import i18n from 'services/i18n';
import { classToFunc } from 'services/decorators/DOM';
// Components
import { Flex, Box } from 'components/Styled';

@i18n('form')
@classToFunc
export default class Criteria extends PureComponent {
  static propTypes = {
    criteria: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
  };

  state = { opencomment: false };

  componentDidMount() {
    if (this.props.criteria.comment) {
      this.setState({ opencomment: true });
    }
  }

  toggleComment = () => {
    this.setState({ opencomment: !this.state.opencomment });
  };

  render() {
    const { criteria } = this.props;

    return (
      <Draggable draggableId={criteria.id.toString()} index={this.props.index}>
        {(optProvider, optSnap) => (
          <React.Fragment>
            <div
              ref={optProvider.innerRef}
              {...optProvider.draggableProps}
              {...optProvider.dragHandleProps}
              tabIndex={null}
              className={cn([
                'modal-draggable-option',
                {
                  'modal-options-isDragging': optSnap.isDragging,
                },
              ])}
            >
              <Flex alignItems="center" className="spacer">
                <Flex className="modal-d-n-d-item spacer" alignItems="center">
                  <span className="icon-drag" />
                  <Box className="spacer">
                    <Row gutter={14}>
                      <Col span={22}>
                        <Form.Item
                          colon
                          validateStatus={criteria.text === '' ? 'error' : ''}
                          help={
                            criteria.text === ''
                              ? this.props.translate('insert', 'error')
                              : ''
                          }
                        >
                          <Input
                            name="text"
                            placeholder={this.props.translate('criteria')}
                            value={criteria.text}
                            onChange={e =>
                              this.props.onChange(e, this.props.index)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <Icon
                          type="down"
                          className={cn([
                            'comment-icon',
                            { open: this.state.opencomment },
                          ])}
                          onClick={this.toggleComment}
                        />
                      </Col>
                    </Row>
                    {this.state.opencomment ? (
                      <Box mt="5px" mr="37px">
                        <Form.Item colon required>
                          <Input
                            name="comment"
                            placeholder={this.props.translate('comment')}
                            value={criteria.comment}
                            onChange={e =>
                              this.props.onChange(e, this.props.index)
                            }
                          />
                        </Form.Item>
                      </Box>
                    ) : null}
                  </Box>
                </Flex>
                <Flex ml={3}>
                  <Icon
                    type="delete"
                    className="action-btn-single"
                    onClick={() => this.props.onRemove(this.props.index)}
                  />
                </Flex>
              </Flex>
            </div>
            {optProvider.placeholder}
          </React.Fragment>
        )}
      </Draggable>
    );
  }
}
